import React, { useMemo } from 'react';

const findMinIndex = (values = []) => {
  let index = 0;
  for (let i in values) {
    if (values[i] < values[index]) {
      index = i;
    }
  }
  return index;
};

export const List = (props) => {
  const { data, renderItem, column = 2, gap = 8, columnWidth = 170, primaryKey = 'id' } = props;
  const [array, height] = useMemo(() => {
    const columnH = new Array(column).fill(0);
    return [
      data?.reduce((res, cur) => {
        const { height, width } = cur;
        const H = (columnWidth * height) / width;
        const index = findMinIndex(columnH);
        res.push({
          H,
          W: columnWidth,
          left: index * (columnWidth + gap),
          top: columnH[index],
          ...cur,
        });
        columnH[index] += H + gap;
        return res;
      }, []),
      Math.max(...columnH),
    ];
  }, [data, column, columnWidth, gap]);

  return (
    <div className="relative w-full" style={{ height }}>
      {array.map((item, idx) => (
        <div
          key={`${item[primaryKey]}-${idx}`}
          className="absolute left-0 top-0"
          style={{
            width: item.W,
            height: item.H,
            transform: `translate3D(${item.left}px, ${item.top}px, 0)`,
          }}
        >
          {renderItem?.(item)}
        </div>
      ))}
    </div>
  );
};
